import i18n from 'i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import {
  type DeleteShipmentRestrictionRequestParams,
  deleteShipmentRestriction,
} from '../data-provider/delete-early-restriction';
import { CACHE_KEYS } from '../types';

export const useDeleteEarlyRestriction = ({ customerKey }: { customerKey: number }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: DeleteShipmentRestrictionRequestParams) => deleteShipmentRestriction(payload),
    onError: () => {
      showNotification({
        message: i18n.t('translation:default.notification.failedToDeleteItem'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CACHE_KEYS.settings(customerKey),
      });
    },
  });
};
